<div class="reset-default-settings-container">
    <button-control
        buttonType="button"
        themeColor="danger"
        [buttonText]="'reset_default_settings.button_text'"
        (onClick)="onResetClick()">
    </button-control>
</div>
